import { Injectable } from '@angular/core';
import { Session } from 'src/app/interface/session/session';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { SessionKey } from 'src/app/enums/session/session-key.enum';
import { MenuConf } from 'src/app/beans/menu/menu-conf/menu-conf.bean';

@Injectable({
  providedIn: 'root'
})
export class MenuSession implements Session
{
    constructor() { }

    get(): MenuConf | SessionCode
    {
        try{
            const menu_json = localStorage.getItem( SessionKey.MENU_CONF ) 

            if (!menu_json) return SessionCode.MISSING_VALUE

            const json = JSON.parse( menu_json )

            if (MenuConf.isKind (json) ) 
                return json as MenuConf
            else
                return SessionCode.PARSING
            
        }catch(error)
        {
            return SessionCode.GENERIC
        }
    }

    set( user : MenuConf ): SessionCode
    {
        if(!MenuConf.isKind (user)) return  SessionCode.INVALID_INPUT

        try{
            localStorage.setItem( SessionKey.MENU_CONF, JSON.stringify(user) ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }

    clear(): SessionCode
    {
        try{
            localStorage.removeItem( SessionKey.MENU_CONF ) 
            return SessionCode.OK
        }catch(error)
        {
            return SessionCode.GENERIC
        }

    }
}

